// @flow

import React from 'react';
import Box from 'components/Box';
import type { AnchorBlockData } from 'api/cms';

const AnchorBlock = ({ data: { anchor } }: { data: AnchorBlockData }) => (
  <Box component="a" data-qa-id={`anchor-block-${anchor}`} id={anchor} />
);
export default AnchorBlock;
